import CommonPage from "../../components/common-page";
import useLanguage from "../../hooks/useLanguage";
import { PageContainer, NumberText, DescriptionText } from "./style";

export default function FourOOne() {
  const [
    {
      pages: { FourOOne: text },
    },
  ] = useLanguage();

  return (
    <CommonPage>
      <PageContainer>
        <img src="/assets/orangebroken.svg" alt="logo" />
        <NumberText variant="h3">401</NumberText>
        <DescriptionText variant="h3">{text.description}</DescriptionText>
      </PageContainer>
    </CommonPage>
  );
}
